import React from 'react'
import { Stack } from '@mui/material'
import { categories } from '../utils/constant'

const Sidebar = ({category}) => {
  return (
    <Stack direction="row" sx={{overflowY:'auto',height:{xs:'auto',md:'94%'},flexDirection:{md:'column'}}}>
    {
        categories.map((e)=>(
            <button className='category-btn' style={{backgroundColor:'white'}} key={e.name} onClick={()=>{category(e.name)}}>
                <span style={{marginRight:'12px'}}>{e.icon}</span>
                <span>{e.name}</span>
            </button>
        ))
    }
        
   
    </Stack>
  )
}

export default Sidebar